import { Presenter } from './IPresenter';

export enum CampaignStatus {
    Created = 'created',
    Done = 'done',
    Error = 'error',
    Rejected = 'rejected',
}

export enum CampaignAccess {
    PRIVATE = 'private',
    PUBLIC = 'public',
}

export interface ICampaign {
    id: string;
    owner_id: string;
    status: CampaignStatus;
    created_at: string;
    created_by?: string;
    modified_at: string;
    result_url: string;
    access: CampaignAccess;
    duration: number;
    title: string;
    page_views: number;
    video_views: number;
    cta_clicks: number;
    credits_consumed: number;
    video_10_percent_views: number;
    video_90_percent_views: number;
    presenter: Presenter;
    gif_url?: string;
    name: string;
    client_key?: string;
}
